import React from 'react';
import { Link } from 'react-router-dom';

// Swiper imports
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const ProjectCardHome = ({ projects = [], sectionClassName, imgStyle }) => {
    const className = sectionClassName || "project-one";

    return (
        <section className={className}>
            <div className="container">

                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={3}
                    navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3000 }}
                    breakpoints={{
                        320: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                >
                    {projects.map((project, index) => (
                        <SwiperSlide key={`${project.id}-${index}`}>
                            <div className="project-two__single">

                                {project.content ? (
                                    <div className="project-two__content-box">
                                        <div className="text-left section-title">
                                            <div className="section-title__tagline-box">
                                                <span className="section-title__tagline">Latest Project</span>
                                            </div>
                                            <h2 className="section-title__title">{project.content}</h2>
                                        </div>

                                        <div className="project-two__btn-box">
                                            <Link to="/infrastructure" className="thm-btn project-two__btn">
                                                View More <span />
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="project-two__img">
                                        <img src={project.image} alt={project.title} style={imgStyle} />

                                        <div className="project-two__content">
                                            <p className="project-two__sub-title">{project.category}</p>

                                            <h3 className="project-two__title">
                                                <Link to={`/infrastructure-details/${project.slug}`}>
                                                    {project.title}
                                                </Link>
                                            </h3>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </section>
    );
};

export default ProjectCardHome;